export default {
  // general/success
  GET_CSV_SUCCESS: "Your CSV has been successfully downloaded",

  // errors
  ERROR_GETTING_CSV: "There was an issue exporting the file. Please try again later.",
};
